export default function validation(response, messages, code) {
  if (response && response.data.error && response.data.error.message
    && (response.data.error.message.indexOf('Il n\'y a pas d\'entité') === 0
    || response.data.error.message.indexOf('There is no such an entity') === 0)) {
    messages.push({
      message: 'validationDevis.notExist',
      parametres: { code: code },
    });
  }
  if (!response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('SAVED_STATE_REQUIRED') === 0) {
      messages.push({
        message: 'validationDevis.saveOrDraftRequire',
        parametres: { code: code },
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/devis/validation.js